import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import {
  AmountDivisorConversion,
} from "@/Core/utils/currencyDealCenter";
import {
  IFInitWalletRechargeFlatRsp,
  IFpayParams,
} from "@/api/apiRsp/IFWalletRsp";
import FromItemPlus from "@/components/FormItemPlus/FromItemPlus";
import type { FormInstance } from '@/componentsUI/Form';
import React from "react";
import DepositAmount from "../compoments/depositAmount/DepositAmount";
import RechargeSpinEntry from "@/pages/rechargeSpinActivity/components/RechargeSpinEntry";
import { isRechargeAmountValid } from "../../rechargeAmount";

const FlatPix = (props: {
  data: IFInitWalletRechargeFlatRsp;
  form: FormInstance<any, any, string | number | symbol>;
  currencyType: string;
  serverCurrencyType?: string;
  formValidator: any;
  rule?: IFpayParams;
}) => {
  const { currencyType, serverCurrencyType, formValidator, rule: currentRule } = props;
  const { t } = useTranslationPlus();

  //金额验证
  const validatorAmount = (va: any, cb: (arg0: any) => any) => {
    if (!formValidator.current) {
      return;
    }
    if (!isRechargeAmountValid(va, currentRule, currencyType, serverCurrencyType)) {
      return cb(t("Wallet.Wrong Amount"));
    }
  };

  return (
    <div className="recharge-flat-pix">
      <FromItemPlus
        field={"amount"}
        label={
          <div>
            <span>{t("Amount")}: </span>
            {currentRule?.decide === 2 && (
              <>
                <span className={`limit`}>
                  {AmountDivisorConversion(Number(currentRule?.min), {
                    currencyType: currencyType,
                  }) +
                    "~" +
                    AmountDivisorConversion(Number(currentRule?.max), {
                      currencyType: currencyType,
                    })}
                </span>
              </>
            )}
          </div>
        }
        rules={[
          { message: t("Wallet.Wrong Amount") },
          { validator: validatorAmount },
        ]}
      >
        <DepositAmount 
          data={currentRule} 
          currencyType={currencyType} 
          serverCurrencyType={serverCurrencyType}
        />
      </FromItemPlus>
      <RechargeSpinEntry />
    </div>
  );
};

export default FlatPix;
